<template>
  <header class="flex items-center justify-end py-4" :class="{ 'sm:justify-between': showFreeUploads }">
    <FreeUploadsCounter v-if="showFreeUploads" class="mr-2" />
    <LimitsBanner
      v-else-if="isPricingUpdateEnabled && isLoggedIn && hasLimits && isLoaded"
      :percentage="averagePercentage"
      :label="headerLabel"
      :always-show-label="false"
      class="mr-2"
      data-testid="header-limits-banner"
      @upgrade="openLimitsModal"
    />
    <div class="flex gap-2">
      <!-- <Button v-if="!isMobile && !isFree" type="link" icon="general.newRecording" data-testid="viewer-header-new-recording-button">
        <span class="hidden md:inline">New Recording</span>
      </Button>
      <Button type="link" icon="general.uploadCloud" data-testid="viewer-header-upload-button">
        <span class="hidden md:inline">Upload</span>
      </Button> -->

      <ImpersonationIndicator />
      <AdminMenu v-if="isSystemAdmin" />
      <Notifications />
    </div>
  </header>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import FreeUploadsCounter from './FreeUploadsCounter.vue';
import Notifications from './notifications/Notifications.vue';
import AdminMenu from './AdminMenu.vue';
import ImpersonationIndicator from './ImpersonationIndicator.vue';
import { LimitsBanner } from '@/storybook/templates/limits';
import { useOrganizationStore } from '@/store/useOrganizationStore';
import { useUserStore } from '@/store/useUserStore';
import { useLimits } from '@/composables/useLimits';
// import { useMobileDetection } from '@/composables/useMobileDetection';
// import { Button } from '@/storybook/button';

const { free } = storeToRefs(useOrganizationStore());
const userStore = useUserStore();
const { isSystemAdmin } = storeToRefs(userStore);
const { hasLimits, isLoaded, averagePercentage, openLimitsModal, planTier, isPricingUpdateEnabled, limitUsages } = useLimits();

const isLoggedIn = computed(() => userStore.isLoggedIn);
const showFreeUploads = computed(() => {
  if (isPricingUpdateEnabled.value) {
    return false;
  }
  return free.value === true;
});

const uploadsUsage = computed(() => limitUsages.value.find(l => l.label === 'Uploads' && !l.disabled));
const headerLabel = computed(() => {
  if (planTier.value === 'free' && uploadsUsage.value) {
    return `FREE LIMIT: ${uploadsUsage.value.current}/${uploadsUsage.value.max}`;
  }
  return undefined;
});

// const { isMobile } = useMobileDetection();
</script>
